// video call connection status - old
export const ConnectionStatus = Object.freeze({
    IN_PROGRESS : 'inprogress',
    CONNECTED : 'connected',
    DISCONNECTED : 'disconnected',
});

// message types
export const MESSAGE_TYPE = Object.freeze({
    TEXT: 'text',
    ATTACHMENT: 'attachment',
    URL: 'url', // not in use currently
    EVENT: 'event' // use for call LOG
})

// videocall provider
export const VIDEOCALL_PROVIDER = Object.freeze({
    AGORA: 'agora',
    TWILIO: 'twilio'
});

// videocall status
export const CALL_STATUS = Object.freeze({
    IN_PROGRESS : 'inprogress',
    CONNECTED : 'connected',
    DISCONNECTED : 'disconnected',
})
// image types
export const ATTACHMENT_IMAGE_TYPES = [
    'png',
    'jpeg',
    'gif',
    'jpg'
]
// file types
export const ATTACHMENT_FILE_TYPE = [
    'pdf',
    'docx',
    'doc',
    'exe'
]


// WEBPACK FOOTER //
// ./src/util/common.js